import { ShieldCheck } from 'lucide-react';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card';
import { Badge } from '@/components/ui/badge';

export function EncryptionStatusBadge() {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Badge
          variant="outline"
          className="cursor-pointer gap-1.5 border-success/30 bg-success/10 text-success hover:bg-success/20 transition-colors"
        >
          <ShieldCheck className="w-3.5 h-3.5" />
          <span className="text-[11px] font-semibold tracking-wide">HIPAA SECURED</span>
        </Badge>
      </HoverCardTrigger>
      <HoverCardContent
        side="bottom"
        align="end"
        className="w-72 border-success/20 bg-card"
      >
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-success" />
            <p className="text-sm font-semibold text-foreground">
              Encryption &amp; Compliance Status
            </p>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-between rounded-md border border-border bg-secondary/50 px-3 py-2">
              <span className="text-xs text-muted-foreground">At-Rest</span>
              <span className="text-xs font-mono font-semibold text-success">
                AES-256 Verified
              </span>
            </div>
            <div className="flex items-center justify-between rounded-md border border-border bg-secondary/50 px-3 py-2">
              <span className="text-xs text-muted-foreground">In-Transit</span>
              <span className="text-xs font-mono font-semibold text-success">
                TLS 1.3 Active
              </span>
            </div>
            <div className="flex items-center justify-between rounded-md border border-border bg-secondary/50 px-3 py-2">
              <span className="text-xs text-muted-foreground">Compliance</span>
              <span className="text-xs font-mono font-semibold text-success">
                SOC 2 Type II
              </span>
            </div>
          </div>

          <p className="text-[10px] text-muted-foreground leading-relaxed">
            All PHI is encrypted at rest with AES-256 and in transit via TLS 1.3.
            Access is logged and auditable per HIPAA §164.312.
          </p>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
